module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skipPackageDimensionChangeIfNoFeeChange),
      expression: "skipPackageDimensionChangeIfNoFeeChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334457"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPackageDimensionChangeIfNoFeeChange) ? _vm._i(_vm.skipPackageDimensionChangeIfNoFeeChange, null) > -1 : (_vm.skipPackageDimensionChangeIfNoFeeChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.skipPackageDimensionChangeIfNoFeeChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.skipPackageDimensionChangeIfNoFeeChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334457"
    }
  }, [_vm._v("Dimension changes: Only alert if FBA fee changed as well")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendAlertForEstimateChanges),
      expression: "sendAlertForEstimateChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334457b"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendAlertForEstimateChanges) ? _vm._i(_vm.sendAlertForEstimateChanges, null) > -1 : (_vm.sendAlertForEstimateChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendAlertForEstimateChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendAlertForEstimateChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendAlertForEstimateChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendAlertForEstimateChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendAlertForOrderDataChanges),
      expression: "sendAlertForOrderDataChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334457c"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendAlertForOrderDataChanges) ? _vm._i(_vm.sendAlertForOrderDataChanges, null) > -1 : (_vm.sendAlertForOrderDataChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendAlertForOrderDataChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendAlertForOrderDataChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendAlertForOrderDataChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendAlertForOrderDataChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334457b"
    }
  }, [_vm._v("Send alerts for FBA fee estimate changes "), _c('small', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.sentrykit.com/knb/fbafeealerts.html"
    }
  }, [_vm._v("[more info...]")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334457c"
    }
  }, [_vm._v("Send alerts for FBA fee changes in order data "), _c('small', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.sentrykit.com/knb/fbafeealerts.html"
    }
  }, [_vm._v("[more info...]")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37353540!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/FBAFeeChangeConfig.vue
// module id = 747
// module chunks = 2